import { render, staticRenderFns } from "./contactUsProperty.vue?vue&type=template&id=25fdb3ca"
import script from "./contactUsProperty.vue?vue&type=script&lang=js"
export * from "./contactUsProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports